import { useInterval } from "@/hooks/useInterval"
import { service } from "@/services/trackings/service"
import { toRechartsData } from "../helpers"
import { StatRecord, StatsProps } from "../types"
import { StatsPieChart } from "./stats-pie-chart"

const reloadTime = 30000

/**
 * StatsBrowser
 */
export const StatsBrowser: React.FC<StatsProps> = ({
  trackingId,
  setIsLoading = () => true,
  interval,
  live = false,
}) => {
  const [data, setData] = React.useState<StatRecord[]>([])
  const updateData = async () => {
    setIsLoading(true)
    const params = interval.from
      ? { from: T.formatISO(interval.from), to: T.formatISO(interval.to) }
      : { to: T.formatISO(interval.to) }
    const { error, data } = G.isNullable(trackingId)
      ? await service.byBrowser(params)
      : await service.trackings.byBrowser(trackingId, params)
    setIsLoading(false)
    if (error) return
    setData(toRechartsData(data.stats))
  }
  React.useEffect(() => {
    updateData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [interval.from, interval.to])
  useInterval(updateData, live ? reloadTime : null)
  return <StatsPieChart stats={data} />
}
